<div class="course-details-breadcrumb-1 bg_image rts-section-gap">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="single-course-left-align-wrapper">
          <div class="meta-area">
            <a class="text-white" [routerLink]="['/']">Início</a>
            <i class="fa-solid fa-chevron-right text-white"></i>
            <a class="active text-white" [routerLink]="['/facintec']"
              >Facintec – Escola Técnica</a
            >
          </div>
          <h1 class="title text-white">Conheça a Facintec – Escola Técnica</h1>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="about-area-start style-two mb--200">
  <div class="container">
    <p class="paragraph">
      Unidade técnica do grupo, localizada em Campo Grande–MS, com ofertas de
      cursos técnicos de nível médio e programas de Educação de Jovens e Adultos
      (EJA), voltados à formação profissional com foco no mundo do trabalho.
    </p>

    <a href="https://facintec.com.br" class="rts-btn btn-primary with-arrow"
      >Saiba mais <i class="fa-solid fa-arrow-right"></i
    ></a>
  </div>
</div>
